export enum RemunerationIndicator {
  /** No remuneration paid */
  NoRemunerationPaid = 0,
  /** Remuneration paid */
  RemunerationPaid = 1,
}
